import { ApiProperty } from "@nestjs/swagger";

export class PreparedStockRequest {
    @ApiProperty()
    itemBarcode: string;
    @ApiProperty()
    unitId: number;
}
